import BaseError from './BaseError';

class PlaybackError extends BaseError {
  constructor(message: string) {
    super('PlaybackError', message);
  }
}

export default PlaybackError;
